import { Listing_Categories, schemas } from '@oneappexchange/oaf-schema';
import { BUCKETS } from '~/modules/config';
import { buildExploreNavigationUrl } from '~/modules/helpers/searchUrlHelper';
import { i18nStore } from '~/modules/stores/i18nStore';
import { ListingCategory } from '~/schemas/content-schema-v1';

export const buildListingCategory = (categoryKey: string): ListingCategory => {
    const categoryLabel = (i18nStore.getState().i18nStaticCache.oaf.category as Record<string, string>)[categoryKey];

    return {
        name: categoryLabel,
        filter: buildExploreNavigationUrl(BUCKETS.EXPLORE_BUSINESS_NEEDS, {
            filterParams: { category: [categoryKey] },
        }),
        filterKey: categoryKey,
    };
};

export function flattenBusinessNeeds(businessNeeds?: Listing_Categories) {
    const businessNeedsCategories = Object.keys(schemas['listing/ListingCategories'].get().properties);

    const categories = [];
    for (const category of businessNeedsCategories) {
        // @ts-expect-error * Automated Type Error Fix
        if (businessNeeds?.[category]?.isSelected) {
            categories.push(category);
        }
    }

    if (businessNeeds) {
        businessNeedsCategories.map(
            // @ts-expect-error * Automated Type Error Fix
            (category) => businessNeeds[category]?.categories?.map((key) => categories.push(key)) ?? [],
        );
    }
    return categories;
}
